import { ShortClientDetailsModel } from '../client/client.model';

export class BrokerMandateSignatureDataModel {
  client: ShortClientDetailsModel;
  createdAt: string;
  state: 'PENDING' | 'APPROVED' | 'REJECTED_WRONG_SIGNATURE' | 'REJECTED_WRONG_DATA';
}
